export default "__VITE_ASSET__CSQFgg_Q__"